import CheckmarkCircleFilled from 'mini-fluent-svg-icons/lib/icons/CheckmarkCircleFilled';
import CircleRegular from 'mini-fluent-svg-icons/lib/icons/CircleRegular';
import React from 'react';
import { FluentSvgIcon } from 'mini-fluent-svg-icons/lib/components/FluentSvgIcon';

const styles = require('./MultiSelectCheckbox.scss');
const classNames = require('classnames/bind').bind(styles);

export interface MultiSelectCheckboxProps {
    isSelected?: boolean;
    wrapInContainer?: boolean;
}

export const MultiSelectCheckbox = ({
    isSelected = true,
    wrapInContainer = false,
}: MultiSelectCheckboxProps) => {
    const selectBoxStyles = classNames(styles.selectBox, isSelected && styles.isSelected);
    const children = (
        <>
            <FluentSvgIcon
                icon={isSelected ? CheckmarkCircleFilled : CircleRegular}
                iconContainerStyles={selectBoxStyles}
                role={'checkbox'}
                aria-checked={isSelected}
            />
        </>
    );

    return wrapInContainer ? <div className={styles.container}>{children}</div> : children;
};
